// Projected PWHL totals: real result for played games, YOUR pick for unplayed ones (3-2-1-0).
export function projectedTotals(predGrid) {
    if (!predGrid?.teams) return null;
    const m = {};
    predGrid.teams.forEach((t) => {
        const c = { gp: 0, w: 0, otw: 0, otl: 0, l: 0, picks: 0 };
        (t.games || []).forEach((g) => {
            const code = g.actual_code || g.predicted_code;
            if (!code) return;
            if (!g.actual_code) c.picks += 1;
            c.gp += 1;
            if (code === "W") c.w += 1; else if (code === "OTW" || code === "SOW") c.otw += 1; else if (code === "OTL" || code === "SOL") c.otl += 1; else if (code === "L") c.l += 1;
        });
        m[t.team_id] = { ...c, pts: c.w * 3 + c.otw * 2 + c.otl };
    });
    return m;
}

export const recStr = (r) => (r ? `${r.w || 0}-${(r.otw || 0) + (r.sow || 0)}-${(r.otl || 0) + (r.sol || 0)}-${r.l || 0}` : "");
